export const MAIN_PAGE_WIDGET_POSITION = 'main_shop_site';

export const HEADER_HEIGHT_OFFSET = -104;
export const BNPL_HEADER_OFFSET = -120;
